import { render } from "./UnloadPermissionTab.vue?vue&type=template&id=afa25a62"
import script from "./UnloadPermissionTab.vue?vue&type=script&lang=js"
export * from "./UnloadPermissionTab.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__